import { z } from 'zod';
import { listSearchSchema } from '@/components/table/routes/listSearchParams.ts';

/**
 * Przekrój Finansów. Wpłaty i budżet to dwa spojrzenia na ten sam wyjazd,
 * nie dwie podstrony — dlatego parametr wyszukiwania, a nie segment ścieżki.
 */
export enum FinanceView {
  PAYMENTS = 'payments',
  BUDGET = 'budget',
}

export const financeViewLabels: Record<FinanceView, string> = {
  [FinanceView.PAYMENTS]: 'Wpłaty',
  [FinanceView.BUDGET]: 'Budżet',
};

/** Widok i wycinek tabeli w jednym adresie — panel spraw prowadzi do „Wpłat” z gotowym filtrem. */
export const tourFinancesSearchSchema = listSearchSchema.extend({
  view: z
    .enum(FinanceView)
    .optional()
    .default(FinanceView.PAYMENTS)
    .catch(FinanceView.PAYMENTS),
});
